export const stepper = {

    submitReport: 'Your submitted report',
    head: 'speKwo Solution Estimate For',
    step1Label: 'Please select the work you would like completed . . .',
    step1Wc: 'Summary Review',
    step1Next: 'Proceed to scheduling',
    step1left: 'Scheduling on final page of solution estimate',

    step2Label: 'Your almost there… just need a little info so we can get this right for you..',
    step2Head: 'Just two questions and you on your way!',
    step2SubHead1: 'Who should Inspect Quote Pro contact to schedule work?',
    step2SubHead2: 'When would you like work completed? ',
    step2SubHead3: 'Is there any more you want to tell us?',
    datePlace: 'Choose a date',
    signDate: 'Date of sign',
    name: 'Your Name',
    email: 'Your Email',
    phone: 'Your Cell',
    role: 'Your Role',
    rolelabel: 'Role',
    closingAttorneyName: 'Closing attorney name',
    closingAttorneyNumber: 'Closing attorney number',
    agentname: 'Agent Name',
    agentEmail: 'Agent Email',
    step2Next: 'SUBMIT REQUEST WORK',
    comingWay: 'If you want one of these folks coming your way',
    step2Back: 'Back to work description',
    nameRequired: 'Name is required',
    agentNameRequired: 'Your Agent Name is required',
    priorRequired: 'Prior to Close Required',
    reInspection: 'Required Field',
    occupiedRequired: 'Occupied Details Required',
    agentEmailRequired: 'Agent Email is required',
    emailRequired: 'Email is required',
    emailInvalid: 'Email is Invalid',
    phoneRequired: 'Phone number is required',
    ClosingFirmRequired: 'Closing Firm required',
    closingNameRequired: 'Name of closing attorney required',
    closingPhoneRequired: 'Phone number of closing attorney required',
    closingDateRequired: 'Closing Date Required',

    step3Label: 'You did it!',
    step3Head1: 'Here is what happens next.',
    step3Head2: 'Your work has been requested',
    step3Head3: 'Your current total of estimated work is ',
    step3Head4: 'First our scheduling team will be in touch with you in next 48 hours to confirm your request.',
    step3Head5: `Once you are scheduled with exact date/time window you will be notified by email and your start up invoice will be sent for 50% of total.   This payment is due 48 hours prior to our team arrival in order to keep your confirmed date.`,
    step3Head6: ' (By my initials here)  I verify I have read and agree to Inspect Quote terms and conditions.',
    step3Next: 'Lets get this party started',
    step3Back: 'Back to questions',
    step3InitialPlace: 'Signature',
    finalContent: 'Our Start and Stay Policy: When our team arrives to start the work, any work they do not complete will be completed on next business day. ',
    finalContentNext: 'We look forward to getting this house in the condition you want it. ',
    spekwoTeam: '~ speKwo Team',
    finalStepHead1: `Thank you for submitting your work request.  To check status of work, write review about your experience or read your very
    exciting home inspection report you can always find that right here and`,
    displayCusWebsite: 'client.spekwo.com',
    finalStepHead2: 'Just type in  your unique 5 digit code and your in. No user name, no password, no secret handshake.',
    finalStepHead3: 'Okay, now go find something fun to do. This house is stressing you out.  No worries, we Got this!',
    close: 'CLOSE',
    download: 'Download',
    print: 'Print',
    clickHere: 'click Here',
    step3Submit: 'SUBMIT TO INSPECT QUOTE PRO',

    statusHead: 'Status of Work',
    beforeAccept: 'Inspect Quote  is reviewing your scope of work in order to assign it to the correct Pro. You will be assigned in the next 24 hours',
    afterAccept: 'Inspect Quote Pro has accepted your list of requested items and will be in contact in the next 24 hours.',
    afterAssigned: 'Inspect Quote Pro has assigned for your list of requested items',
    completedStatus: 'Inspect Quote Pro has completed the work',
    beforeCompletedStatus: 'Inspect Quote Pro is progressing your work',
    viewFile: 'View your Inspect Quote Solution Estimate',
    back: 'Back to Main Page',
    downloadPdf: 'Save as Pdf',
    idLabel: 'Unique ID',
    printHead: 'Inspect Quote Solution Estimate',
    idContent: 'to view your solution estimate or approve work go to  client.spekwo.com   and enter your unique ID. ',
    agent: 'Agent',
    client: 'Client',
    buyerAddress: 'Property Address',
    pdfFooter1: {
        head: 'Who, What,  Inspect Quote, Huh?',
        'one': `Glad you asked. Inspect Quote is a trusted and neutral party for buyers and sellers. Inspect Quote will create an estimate for the items your home inspection identified as
        “repair/ replace”.`,
        'two': 'We do this by utilizing the most recent data on cost of available labor and materials. ',
        'three': 'If the ordering party elects to have any of the work done a Inspect Quote approved Pro will complete the work at the above price, Guaranteed!'
    },
    pdfFooter2: {
        head: 'How does unique ID work?',
        'one': `Each Inspect Quote solution estimate completed comes with a unique ID which is a 5 character code. If you would like to view a copy of your
        home inspection report (the one you submitted)  Or If you would like to view your solution estimate or even if you would like to request some
        or all of the work quoted to be completed… you can do that all here! `,
        'two': 'Easy just go to ',
        'three': 'and enter your Inspect Quote unique ID, which for yours is: '
    },
    pdfFooter3: {
        head: 'Who is speKwo and What do they do?',
        'one': `We are glad you asked . speKwo is a trusted and neutral party providing quotes for both buyers and sellers.`,
        'two': 'speKwo creates quotes just like this one for our broker clients.  We do this with our proprietary system which quotes all items from your home inspection report utilizing empirical data of labor and material cost for our area.  Not only can we quote the work, but we can complete the work for the price quoted!',
        'three': 'Our team provides quotes and repairs for nearly every real estate firm in the area.',
        'fourth': 'All quotes are valid for 90 days. Quotes are based on pre-allocated measurements which may be subject to change.',
    },
    financialResParty: {
        title: 'Financially Responsible Party',
        name: 'Name',
        role: 'Role',
        email: 'Email',
        phone: 'Phone'
    },
    transactionInfo: {
        title: 'Transaction Info',
        closingFirm: 'Closing Firm',
        email: 'Email',
        agent: 'Agent',
    },
    reinspectionDate: 'Reinspection Date',

    buyerAgent: 'Buyer Agent',
    sellerAgent: 'Seller Agent',
    transactionClose: 'Has your transaction closed yet?',
    options: [
        { value: true, viewValue: 'Yes' },
        { value: false, viewValue: 'No' },
    ],
    scheduleOptions: [
        { value: 'reInspection', viewValue: 'Reinspection preferred' },
        { value: 'sentPicture', viewValue: 'Prefer completed pictures sent to me' },
    ],
    occupiedOptions: [
        { value: 'vacant', viewValue: 'Vacant' },
        { value: 'occupied_by_tenant', viewValue: 'Occupied by tenant' },
        { value: 'occupied_by_current_owner/seller', viewValue: 'Occupied by current owner/seller' },
        { value: 'occupied_by_new_owner/buyer', viewValue: 'Occupied by new owner/buyer' },
    ],
    dayOfContact: {
        contactName: 'Name',
        contactEmail: 'Email',
        contactPhone: 'Cell Number',
    },
    dayOfContactRequired: {
        contactNameRequired: 'Contact Name Required',
        contactEmailRequired: 'Contact Email Required',
        contactPhoneRequired: 'Contact Cell Number Required',
    },
    finResponsibleAgentRequired: {
        roleRequired: 'Financial Responsible Agent Role Required',
        paymentRequired: 'Responsible For Payment Required',
    },
    buyerAndSellerRequired: {
        buyerNameRequired: 'Buyer Name Required',
        sellerNameRequired: 'Seller Name Required',
    },
    buyerAndSeller: {
        buyerAgentName: 'Buyer Agent Name',
        sellerAgentNAme: 'Seller Agent Name',
    },
    signatureError: 'Signature Required',
    infoRequired: {
        nameRequired: 'Name Required',
        emailRequired: 'Email Required',
        phoneRequired: 'Phone Required',
    },
    questions: {
        title: 'Here are a few of the most common answers to your questions…',
        firstQuestion: {
            question: 'What if I want to add work you didn’t quote?',
            answer: `No problem. We can do it. If you add work while our team is there working, sometimes they will have the time to do handle it the same day, other times we may have to come back.Any work you are adding or work that is changing will put into quote and sent to you via text message. You will need to approve and electronically sign that quote so we can proceed.`,
        },
        secondQuestion: {
            question: 'Who is coming to my house?',
            answer: `We have a 2 or 3 person team coming your way. The number of Pro's on each team changes based on the amount of work you requested. The pro's on the assigned team have extensive experience and will be able to handle anything you throw at them.`,
        },
        thirdQuestion: {
            question: 'What day/time will the team be to my house? ',
            answer: `Once a week we do scheduling for the following week. We do our best to give you the date you requested, however we do take work in the chronological order it arrives.Once you are scheduled you will be notified by email of our arrival date and time. `,
        },
        fourthQuestions: {
            question: 'I’m on a major deadline… how likely is it you will get this done in time?',
            answer: `We do work for real estate brokers… we have the ability to make realistic deadlines. Now that you have submitted your request, feel free to reach out to us at the office and let’s talk through the urgency and scheduling.`,
        },
        fifthQuestion: {
            question: 'How is the communication?',
            answer: `Each Friday we hold our scheduling meeting; Now that you have requested work You will be updated each week on Friday afternoon.If you are scheduled for the following week you will be given your date and time of arrival.Note until you are assigned exact date and time you will receive weekly communication from our team confirming the 4 day window you will be scheduled for.`,
        },
    },
    checkout: {
        clientName: 'Client Name',
        clientEmail: 'Client Email',
        clientPhone: 'Client Phone',
        clienRole: 'Client Role',
        agentName: 'Agent Name',
        agentEmail: 'Agent Email',
        isClosedPay: 'Has your transaction closet yet?',
        closingDate: 'When is closing date?',
        beginingDate: 'What is the earliest date our team can begin work?',
        closingAttorney: {
            question: 'Name & phone number of closing attorney?',
            name: 'Name',
            phone: 'Phone',
        },
        questions: {
            deadLineDate: 'What is absolute deadline you would like work completed by?',
            isPrior: 'Does this work need to be completed prior to closing?',
            isOccupied: 'Is house vacant or occupied?',
            workResponsibleRole: 'Who should we discuss our progress and completed work with?',
            reInspection: 'Will you schedule a Re-inspection or Would you prefer completed pictures? ',
            responsibleToPayment: 'Who is responsible for payment?',
            whoWorkContact: 'Who should we discuss our progress with? ',
            whoPaymentContact: 'Who is responsible for payment contact? ',
            workOrPayName: 'Type Name here',
            workOrPayEmail: 'Type Email here',
            workOrPayPhone: 'Type Phone here',
            PayorRole: 'Payor Role:',
            paymentContactEmail: 'Payment Contact Email',
            paymentContactPhone: 'Payment Contact Phone',
            whoContact: {
                question: 'Who do we contact for access the day of work?',
                name: 'Name',
                phone: 'Phone',
                email: 'Email',
            },
        },
        sellerAgentName: 'Seller Agent Name',
        buyerAgentName: 'Buyer Agent Name',
        signature: 'Typed signature from client',
    },
    schedulingQuestions: 'Scheduling Questions',
    accessQuestions: 'Access Questions',
    emailText: 'For security Please email combo lockbox code to',
    scheduleMail: 'scheduling@spekwo.com',
    decision: 'Financial and Decision Making',
    brokerAgent: 'Broker/ Agent Names',
    readTerms: 'Please type your name here to acknowledge you have read our',
    termsandcond: 'Terms and conditions',
    roleId: {
        currentOwnerAndSeller: '7fbea184-0a71-11ec-8dcc-1722801e9c5c',
        ownerAndBuyer: '97f57cc8-0a71-11ec-8c9e-d7e9efc7b97c',
        buyerBroker: 'af946e84-0a71-11ec-a1ac-c77b1631d3f6',
        sellerBroker: 'c5573602-0a71-11ec-b562-cba27195b2b8',
    },
    statement: 'Oh By the way….Our team can literally handle everything and because we are there working our cost tends to be lower than the specialty trade companies.',
    additionalWork: 'Is there any other work you would like to add in ?',
    backPage: 'Back',
    clientName: 'Client Name:',
    sellingBroker: 'Selling Broker:',
    clientRequest: 'Timeline Request:',
    quoteRequested: 'Quote Requested:',
    quoteDelivered: 'Quote Delivered:',
    quoteCompleted: 'Your quote was completed in ',
    homePageRow1: 'You have just saved an average of 6 phone calls',
    homePageRow2: 'and 11 hours in coordinating, meeting, and waiting',
    homePageRow3: 'for multiple quotes.',
    haveQuestions: 'Have Questions? Call us 866.646.0200 or Email us info@speKwo.com',
    thankYou: 'Thank you for choosing speKwo and allowing us to provide you with accurate quotes and reliable repairs. We are a neutral party. We conduct repairs and quotes for all sides of the real estate transaction. Our pricing is the same for The seller as it is for the buyer. Our quotes are not swayed by the real estate market or the participants in it. Our quote is considered by industry experts to be credible and transparent.',
    xRay1: 'X-ray Vision:',
    xRay2: 'This is a technology all of us would like to have to avoid surprises behind walls and floors.  We also don’t have it. The large majority of the items from your recent inspection are clear. Our repair description and our prices reflect that. It is not our goal or intention to start repair work only to change the pricing. We believe in honest, transparent pricing structure',
    allGood1: 'All good',
    allGood2: 'All speKwo solution estimates are good for 60 days. Quotes are provided based on chronicled data, inspector descriptions & pictures, pricing catalogues, and the amount of time and materials it will take for our team to complete the task at hand.  These quotes are given to you with specific quantities, square or lineal footage, and in detailed decription of how repair will occur. By providing you the quote in this manner it makes our pricing fully transparent.',
    viewSolution: 'To View your Solution Estimate or Schedule repairs',
    whoSpekwo1: 'Who is speKwo and what do they do? Glad you asked. We are company who provides Quotes and Repairs for all items on the home inspection. We are a neutral 3rd party who will provide the same exact quote to the seller as we do for the buyer. We do this with our proprietary system which quotes all items from the home inspection in 72 hours or less. Our quotes are accurate and so reliable we can complete the work for the price we quoted!',
    pdfCost: 'Total Quote',
    page: 'Page',
    office: 'Office.866.646.0200',
    webSite: 'Website: speKwo.com',
    emails: 'Email: Info@speKwo.com',
    commonQA: 'Common Questions, Honest Answers.',
    quoteComeFrom: 'This quote was requested and  paid for by someone associated with this transaction. The average quote take 3-5 hours to prepare so We don’t make a habit of providing unwanted quotes.',
    wroteThisQuote: 'Our quoting team is made up of actual humans who have retired from their career in trades.',
    firmsSpeKwoWorkWith: 'We work with large firms & boutique firms, solo agents & teams. Ask for us about it  we probably know the same people.',
    whyWorkWithSpeKwo: 'In every transaction both sides seek an equitable agreement. We provide the same quote, the same repairs, and the same level of service to all parties in the transaction. If our quote was provided to a seller, the buyer can call us after closing and get the same pricing.',
    whenCanDoRepairs: 'We can complete repairs PRE or POST close.  We will complete the repairs for the Buyer, Seller, Broker or anyone else who thinks we’re awesome.',
    whenCanBeHere: 'I am sure the answer you want to hear is “we can be there this afternoon”.  The more realistic answer is we can have a team to you in 7-10 days. We prioritize All PRE-Close repairs. We will clearly and constantly communicate with you on when we will be there so you can plan accordingly.',
    repairProcessWork: 'Our hope is to make this as painless as possible. You will not be receiving multiple calls or multiple visits from various strangers. You will have one point of contact in our office for scheduling and invoicing.  You will have one repair team equipped to handle the items you have requested.',
    whoDoingRepairs: 'Our repair team consists of full-time employees who are professional tradesmen. They enjoy their work and take pride in a quality outcome.',
    canRepairsPaid: 'Yes assuming one broker in the transaction has worked with speKwo previously we have a simple protocol in place allowing the final invoice to be paid from closing.'
};
export const reportList = {
    noData: 'No reports present',
    noWorkRequest: 'No Work Requested ,Please go to Schedule Repairs and  select the work you want',
    noSolution: 'No solution has been approved',
    noSolutionRequest: 'No solution requestes',
    tableHeading: {
        itemNumer: 'Number',
        category: 'Category',
        description: 'R/R Description',
        solution: 'Solution',
        totalCost: 'Cost',
        toggle: 'Toggle',
        total: 'Total Cost'
    },
    feedback: {
        thankYou: 'Thank you',
        thanksText: 'for choosing to work with Inspect Quote tradesmen.Tell us about your experience',
        wont: 'Wont hire again',
        excellent: 'Excellent',
        communication: 'Communication',
        punctuality: 'Punctuality',
        qualityOfWork: 'Quality of work',
        reviewExp: 'Write Review about your experience:',
        review: 'Review',
        afterReview: 'Given Feedback',
        noReview: 'No review added',
        saveBtn: 'Save',
        happyUrl: 'assets/images/ecommerce/joy.png',
        sadUrl: 'assets/images/ecommerce/sad.png'
    },
    inspection:
    {
        hello: 'Good day',
        thanks: 'We are glad to be working with you. From here you can review you can view your solution estimate , request work, or review your uploaded paperwork.',
        whatWould: 'What would you like to do today?',
        requestWork: 'Schedule Repairs',
        customeSolutions: 'Customize Quote for Presentation',
        insReport: 'View my submitted home inspection report',
        solEstimate: 'View Inspect Quote Solution Estimate',
        viewEstimate: 'Review Solution Estimate',
        writeReview: 'Write review of Inspect Quote pro',
        checkStatus: 'Check status of work',
        thanksText: 'for choosing to work with Inspect Quote tradesmen.Tell us about your experience',
        validQuote: 'This Quote is valid for the next 30 days, after which values may be subject to change.',
        proFeedback: 'with the Inspect Quote pro who recently completed work for you',
        thankYou: 'Thank you',
        wont: 'Wont hire again',
        excellent: 'Excellent',
        communication: 'Communication',
        punctuality: 'Punctuality',
        qualityOfWork: 'Quality of work',
        reviewExp: 'Write Review about your experience:',
        saveBtn: 'Save',
        review: 'Review',
        cost: 'Total Quote',
        happyUrl: 'assets/images/ecommerce/joy.png',
        sadUrl: 'assets/images/ecommerce/sad.png',
        noPdfFound: 'No pdf has been uploaded',
        logoutTip: 'Click here to logout',
        logoQuote: 'Instant quotes & reliable repairs for all items on your home inspection',
    },
    reportIdHead: 'Inspect Quote Unique Code for your report:',
    estimatePage: {
        client: 'Client',
        buyerAddress: 'Property Address',
        city: 'City',
        state: 'State',
        zip: 'Zip',
        estimate: 'Estimate for Work',
        uniqueCode: ' Unique Code',
        welcomeBack: ' Welcome back',
        ThankyouNotes: `
        Thank you again for choosing Inspect Quote to help you gain clarity and assurance into your recent home inspection.
        From this page you can view your solution report and from your solution report you can request that specific work to be done.`,
        requestBtn: 'Request work from Estimate',
        statusOfOrder: 'Check status of work request :',
        feedbackPro: 'Feedback on Pro :',
        shareExp: 'Share your experience',
        view: 'View my Inspect Quote Solution Report',
        downloadBtn: 'Download',
        emailBtn: 'Email',
        viewBtn: 'View'
    },
    saveAsPdf: 'Save as PDF',
    print: 'Print',
    originalSolution: 'Original Solution',
    customizePage: 'Customize Solution',
    multicustomizePage: 'Multi Customize Solution',
    solutionQuote: 'You requested a quote, we provided it right here.',
    solutionQuoteEstimate: '*Remember the price quoted is the price repaired',
    customizeQuote: 'This option allows you to review each item we have quoted and only select the item you want to present.',
    repairQuote: 'Choose the items you would like repaired and include additional items you would like completed.',
    title: {
        cutomizeSolution: 'Schedule Solution Report',
        originalSolution: 'speKwo Solution Estimate',
        requestSolution: 'Customize Solution Quote',
    }

};

export const login = {

    loginHeading: 'ENTER YOUR UNIQUE CODE TO VIEW YOUR PERSONAL SOLUTION ESTIMATE',
    loginRequired: 'Unique Code is required',
    loginBtn: 'LOGIN',
    loginPlace: 'Unique Code'
};
export const status = {
    'Accepted': 'Accepted',
    'Completed': 'Completed',
    'Allocated': 'Allocated',
    'Client Reviewed': 'Client Reviewed',
    'Scheduling': 'Scheduling',
    'Scheduled': 'Scheduled',
    'In Progress': 'In Progress',
    'Declined': 'Declined',
    'se_complete': 'S.E Complete',
    'cancel_work_request': 'Cancel Work Request',
};

export const localComponentValues = {
    fromHome: 'fromHome',
    goToStatus: 'goToStatus',
    feedback: 'feedback',
    firstPage: 'firstPage',
    thirdPage: 'thirdPage',
    secondPage: 'secondPage',
    communication: 'Communication',
    punctuality: 'Punctuality',
    quality: 'Quality',
    success: 'success',
    sad: 'sad',
    happy: 'happy',
    status: 'status',
    viewSolution: 'viewSolution',
    requestWork: 'requestWork',
};



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/utils/stepper.ts